const zh = {
	risk: {
		riskTitle: '风险订单管理',
		tips1: '您有 ',
		tips2: ' 笔订单存在风险，请在交易发起的7天内联系持卡人进行确认，过期则交易自动撤销。pingpong将协助您完成。',
		tipsNoPermission: ' 笔风险订单，PingPong将会审核风险并做出决策，如有疑问请联系我们，感谢理解。',
		emptyText: '您目前没有风险订单'
	},
	table: {
		tradingTime: '交易时间',
	  storeName: '网站',
		omniStoreName: '门店/网站',
		groupName: '群组',
		outFlowId: '交易流水号',
		currency: '交易币种',
		payBrand: '支付方式',
		amount: '交易金额',
		type: '交易类型',
		status: '交易状态',
		action: '操作',
		detail: '详情'
	}
}

export default zh
